export default __webpack_public_path__ + "static/media/productos.fd19f59f.jpg";